import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e538198"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "core-func-wrapper paddingTop40" }
const _hoisted_2 = { class: "core-func" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-center" }, "产品核心功能", -1))
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "absolute zIndex2" }
const _hoisted_7 = { class: "name paddingBot12" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "show-img" }
const _hoisted_10 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coreData, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.name,
            class: "relative marginBot28"
          }, [
            _createElementVNode("img", {
              src: item.bgUrl,
              class: "bg-url"
            }, null, 8, _hoisted_5),
            _createElementVNode("span", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(item.name), 1),
              _createElementVNode("span", _hoisted_8, _toDisplayString(item.content), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("img", {
                src: item.showImg
              }, null, 8, _hoisted_10)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}